module.exports = __webpack_public_path__ + "img/apple_pie_sugar_cinnamon.0787f62c.jpg";